import { render } from "./EachRestaurantMenu.vue?vue&type=template&id=809ad832&scoped=true"
import script from "./EachRestaurantMenu.vue?vue&type=script&lang=js"
export * from "./EachRestaurantMenu.vue?vue&type=script&lang=js"

import "./EachRestaurantMenu.vue?vue&type=style&index=0&id=809ad832&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-809ad832"]])

export default __exports__